import type { JobView } from '@api/devices/contracts';

/** How many jobs one Work group shows before the next page. */
export const WORK_PAGE_SIZE = 30;

const stamp = (value: string | null | undefined) => {
  const n = value ? Date.parse(value) : Number.NaN;
  return Number.isFinite(n) ? n : 0;
};

/** The words a Work search matches: device, customer, runbook or script name, who asked and why. The API's history search matches the same. */
export function requesterLabel(job: JobView) {
  return job.automatic ? 'Automatic' : job.requestedByMe ? 'You' : 'Teammate';
}

export function matchesWorkQuery(job: JobView, query: string) {
  const tokens = query.toLowerCase().split(/[\s\u0000]+/).filter(Boolean);
  if (!tokens.length) return true;
  const haystack = [job.deviceTitle, job.deviceHostname, job.organizationName, job.title, requesterLabel(job), job.reason].filter(Boolean).join('\n').toLowerCase();
  return tokens.every(token => haystack.includes(token));
}

/** Finished orders by the latest thing that happened, so a job just marked checked is first (WRMM-167). */
export function lastChange(job: JobView) {
  // Only an expired job changed at expiresAt. On any other job that time is a deadline, often still ahead.
  return Math.max(stamp(job.requestedAt), stamp(job.canceledAt), stamp(job.checked?.at), stamp(job.run?.finishedAt), stamp(job.approval?.decidedAt),
    job.state === 'expired' ? stamp(job.expiresAt) : 0,
    // Closed by removing its device (WRMM-226): the removal was its last change.
    (job.state === 'failed' || job.state === 'unknown_outcome') && !job.checked ? stamp(job.deviceRemovedAt) : 0);
}

export function orderWorkGroup(key: string, jobs: JobView[]) {
  if (key !== 'done') return jobs;
  return [...jobs].sort((a, b) => lastChange(b) - lastChange(a) || stamp(b.requestedAt) - stamp(a.requestedAt) || a.id.localeCompare(b.id));
}
